import { Link } from "react-router-dom";
import { dynamicImage } from "../../../utils";
import { routes } from "../../../routers/routes";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { toggleSidebar } from "../../../reduxToolkit/reducers/layout/themeCustomizerSlice";
import { Image } from "../../../coreComponents/Image";
import SvgIcon from "../../../coreComponents/SvgIcon";

const LogoWrapper = () => {
  const dispatch = useAppDispatch();

  return (
    <>
      <div className="logo-wrapper">
        <Link to={routes.MapView}>
          <Image className="img-fluid for-light" src={dynamicImage(`logo/logo-dark-resized.png`)} alt="" />
          <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo-dark-resized.png`)} alt="" />
        </Link>
        <div className="toggle-sidebar" onClick={() => dispatch(toggleSidebar())}>
          <SvgIcon className="sidebar-toggle" iconId="toggle-icon" />
        </div>
      </div>
      <div className="logo-icon-wrapper">
        <Link to={routes.MapView}>
          <Image className="img-fluid" src={dynamicImage(`logo/logo-sm-resized.png`)} alt="" />
        </Link>
      </div>
    </>
  );
};

export default LogoWrapper;
